import React from 'react';

export function GradientDownArrows () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="365"
      height="260"
      fill="none"
      viewBox="0 0 365 260"
    >
      <g clipPath="url(#clip0_18777_9962)" opacity="0.8">
        <path
          fill="url(#paint0_linear_18777_9962)"
          d="M124.188 165.943L181.373 240l57.185-74.057h-34.74V-20h-43.803v185.943h-35.827z"
        />
        <path
          fill="url(#paint1_linear_18777_9962)"
          d="M219 111.923L254 157l35-45.077h-21.261V-20h-26.811v131.923H219z"
        />
        <path
          fill="url(#paint2_linear_18777_9962)"
          d="M74 111.923L109 157l35-45.077h-21.261V-20h-26.81v131.923H74z"
        />
        <path
          fill="url(#paint3_linear_18777_9962)"
          d="M299 79.415L320.508 107 342 79.415h-13.057V-20h-16.474v99.415H299z"
        />
        <path
          fill="url(#paint4_linear_18777_9962)"
          d="M21 79.415L42.508 107 64 79.415H50.943V-20H34.469v99.415H21z"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_18777_9962"
          x1="181.373"
          x2="181.373"
          y1="-20"
          y2="240"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#E6F3F2" stopOpacity="0.8" />
          <stop offset="0.54" stopColor="#fff" />
          <stop offset="1" stopColor="#F8F8F8" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18777_9962"
          x1="254"
          x2="254"
          y1="-20"
          y2="157"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#E6F3F2" stopOpacity="0.8" />
          <stop offset="0.54" stopColor="#fff" />
          <stop offset="1" stopColor="#F8F8F8" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18777_9962"
          x1="109"
          x2="109"
          y1="-20"
          y2="157"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#E6F3F2" stopOpacity="0.8" />
          <stop offset="0.54" stopColor="#fff" />
          <stop offset="1" stopColor="#F8F8F8" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_18777_9962"
          x1="320.5"
          x2="320.5"
          y1="-20"
          y2="107"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#E6F3F2" stopOpacity="0.8" />
          <stop offset="0.54" stopColor="#fff" />
          <stop offset="1" stopColor="#F8F8F8" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_18777_9962"
          x1="42.5"
          x2="42.5"
          y1="-20"
          y2="107"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#E6F3F2" stopOpacity="0.8" />
          <stop offset="0.54" stopColor="#fff" />
          <stop offset="1" stopColor="#F8F8F8" stopOpacity="0.8" />
        </linearGradient>
        <clipPath id="clip0_18777_9962">
          <path fill="#fff" d="M0 0H365V260H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
